import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-brand-navy pt-32 pb-24 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-104">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-amber/10 blur-[120px] rounded-full pointer-events-none" data-id="element-105" />

      <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-107">
          <div className="flex flex-col items-center" data-id="element-108">
            <span className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold tracking-tight" data-id="element-109">
              <span className="text-brand-amber" data-id="element-110">R</span>
              <span className="text-brand-amber text-[0.75em]" data-id="element-111">
                EINOSO
              </span>{' '}
              <span className="text-white" data-id="element-112">B</span>
              <span className="text-white text-[0.75em]" data-id="element-113">USINESS</span>
            </span>
            <span className="text-white text-sm md:text-base tracking-[0.35em] uppercase mt-1" data-id="element-114">
              Consultant LLC
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} data-id="element-115">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-800 text-brand-amber text-sm font-medium mb-8" data-id="element-116">
            <ShieldCheck size={16} data-id="element-117" />
            Especialistas en Reparación de Crédito
          </span>
        </motion.div>

        <motion.h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-8 leading-[1.15] max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-118">
          Deja de pagar el precio de un mal crédito y{' '}
          <span className="text-brand-amber" data-id="element-119">
            recupera tu poder financiero.
          </span>
        </motion.h1>

        <motion.p className="text-lg md:text-xl text-slate-300 mb-12 max-w-3xl mx-auto leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-120">
          En Estados Unidos, tu puntaje de crédito es tu reputación financiera.
          Eliminamos los obstáculos de tu pasado para que los bancos vuelvan a
          decirte "SÍ" al comprar tu casa, tu auto o solicitar tarjetas premium.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col items-center gap-4" data-id="element-121">
          <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-122">
            <a href="https://calendly.com/jesus-reinosobusinessconsultant/30min" target="_blank" rel="noopener noreferrer" className="bg-brand-amber hover:bg-brand-amberHover text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 shadow-[0_0_40px_-10px_rgba(217,119,6,0.5)] hover:shadow-[0_0_60px_-15px_rgba(217,119,6,0.6)] hover:-translate-y-0.5 inline-block" data-id="element-123">
              VERIFICAR MI ELEGIBILIDAD AHORA
            </a>
            <a href="https://creditheroscore.com/redirect.asp?guid=0WXBQVBN6VZ4&sid=MKARES7S4" target="_blank" rel="noopener noreferrer" className="border border-slate-500 hover:border-brand-amber text-slate-300 hover:text-brand-amber px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 hover:-translate-y-0.5 inline-block" data-id="element-124">
              MONITOREA TU CRÉDITO
            </a>
          </div>
          <p className="text-sm text-slate-400 flex items-center gap-2 mt-4" data-id="element-125">
            <ShieldCheck size={14} className="text-slate-500" data-id="element-126" />
            Consulta confidencial basada en la Ley Federal de Informes Justos de
            Crédito (FCRA).
          </p>
        </motion.div>
      </div>
    </section>;
}